import { axios } from '@Root/API'

export const remove = contactId => {
	return axios.delete(`contacts/${contactId}`)
}
